import { toObjectMap } from "@@/utilities/dictionary";
import { generateId } from "@@/utilities/generate-id";

const errorCodes = [
    "UNAUTHORIZED",
    "UNAUTHENTICATED",
    "BAD_REQUEST",
    "NOT_FOUND",
    "INTERNAL_ERROR",
] as const;
type ErrorCode = (typeof errorCodes)[number];
const errorCodesMap = toObjectMap<ErrorCode>([...errorCodes]);

type ApplicationError<ErrorData = unknown> = {
    _id: string;
    _type: "APP_ERROR";
    message?: string;
    publicMessage?: string;
    error?: ErrorData;
    errorCode: ErrorCode;
    errorSubCode?: string;
};

const appError = <ErrorData = unknown>(params: {
    errorCode: ErrorCode;
    publicMessage?: string;
    message?: string;
    error?: ErrorData;
    errorSubCode?: string;
}): ApplicationError => {
    return {
        _id: generateId({ length: 6, prefix: "err__" }),
        _type: "APP_ERROR",
        ...params,
        message: params.message || params.publicMessage,
    };
};

type ApplicationErrorResponse = {
    reason: string;
    // todo!, make this good
};
export { errorCodes, errorCodesMap, appError as createAppError };
export type { ErrorCode, ApplicationError, ApplicationErrorResponse };
